// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// import firebase from "firebase";

// const firebaseApp = firebase.initializeApp({
//   apiKey: "AIzaSyDKinSR2NsGZYZpItbLx_n3FHV8b9MjDDw",
//   authDomain: "cryptoweb-74947.firebaseapp.com",
//   projectId: "cryptoweb-74947",
//   storageBucket: "cryptoweb-74947.appspot.com",
//   messagingSenderId: "969932973944",
//   appId: "1:969932973944:web:50e842068a18b2754a4a8d",
//   measurementId: "G-DFE6W8CZSR",
// });

// //export default db;
// const db = firebaseApp.firestore();
// const auth = firebaseApp.auth();
// const storage = firebaseApp.storage();

// export { db, auth, storage };

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDKinSR2NsGZYZpItbLx_n3FHV8b9MjDDw",
  authDomain: "cryptoweb-74947.firebaseapp.com",
  projectId: "cryptoweb-74947",
  storageBucket: "cryptoweb-74947.appspot.com",
  messagingSenderId: "969932973944",
  appId: "1:969932973944:web:50e842068a18b2754a4a8d",
};

// const app = initializeApp(firebaseConfig);
// const auth = getAuth(app);
// const db = getFirestore(app);
// const storage = getStorage(app);

// export { app, db, auth, storage };

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export default app;
